'use client'

import { useEffect, useRef } from 'react'
import { useSearchParams } from 'next/navigation'
import { useRouter } from 'next/router'
import { ServiceTimeKindType } from '@ancon/wildcat-types'
import getOutletOrderFormats from '@ancon/wildcat-utils/outlet/getOutletOrderFormats'
import getOutletNextReadyToOrderTime from '@ancon/wildcat-utils/outlet/getOutletNextReadyToOrderTime'

import useAppSelector from '../../../store/hooks/useAppSelector'
import useAppDispatch from '../../../store/hooks/useAppDispatch'
import {
  outletSetIsVisibleOutletDetailsModal,
  outletSetOutletFilters,
} from '../store/outletSlice'
import { OutletFilters } from '../types'
import { outletListItemSelector } from '../store/outletSelector'
import hasOutletDetailsURLFlag from '../utils/hasOutletDetailsURLFlag'
import isOutletAcceptingOfflineOrders from '../utils/isOutletAcceptingOfflineOrders'

export default function OutletDetailsURLFilter() {
  const dispatch = useAppDispatch()

  const router = useRouter()

  const searchParams = useSearchParams()

  const isTriggeredRef = useRef<boolean>(false)

  const outletListItem = useAppSelector(outletListItemSelector)

  useEffect(() => {
    const hasOnlyOutletDetailsFlag = hasOutletDetailsURLFlag(searchParams)

    if (
      hasOnlyOutletDetailsFlag &&
      !isTriggeredRef.current &&
      !!outletListItem
    ) {
      isTriggeredRef.current = true

      const orderFormats = getOutletOrderFormats(outletListItem)

      const hasMultipleOrderFormats = orderFormats.length > 1

      if (hasMultipleOrderFormats) {
        // If multiple order formats, consider the first one as default
        const defaultOrderFormat = orderFormats[0]

        /** Set outlet filters (order format and service time) */
        const outletFilters: Partial<OutletFilters> = {
          orderFormat: defaultOrderFormat,
        }

        const isAcceptingOfflineOrders =
          isOutletAcceptingOfflineOrders(outletListItem)

        if (isAcceptingOfflineOrders) {
          const orderTimeMoment = getOutletNextReadyToOrderTime(
            outletListItem,
            defaultOrderFormat,
          )

          outletFilters.serviceTime = {
            kind: ServiceTimeKindType.AtSpecifiedTime,
            time: orderTimeMoment.toISOString(),
          }
        }

        dispatch(outletSetOutletFilters(outletFilters))
      }

      dispatch(outletSetIsVisibleOutletDetailsModal(true))
    }
  }, [dispatch, outletListItem, router, searchParams])

  return null
}
